import {RedirectCommand, Router} from '@angular/router';

export const guardRedirect = (path: string, router: Router, response?: ResponseInit): RedirectCommand | boolean => {
  // For server-side rendering, set the response status to 403 Access Denied
  if (response) {
    response.status = 403;
    response.statusText = 'Access Denied';
    return true;
  }

  return new RedirectCommand(router.createUrlTree([path]), {
    browserUrl: router.currentNavigation()?.initialUrl,
  });
};
